import app from '@/app';
import templateUrl from './unifilarParametersComments-detail.html';

/* @ngInject */
function Controller(
  $controller,
  UnifilarParametersComments,
  $http,
  $uibModal,
  $timeout,
  AlertService,
  $state,
  UnifilarParametersCache
) {
  const $ctrl = this;
  var planId;
  const resource = UnifilarParametersComments;

  $controller('AbstractEntityDetailController', {
    $ctrl,
    resource: UnifilarParametersComments,
    type: 'unifilarParametersComments'
  });

  var transition = $ctrl.transition;
  $ctrl.transition = params => {
    transition(params);
    planId = params.id;

    $ctrl.queryFromParent = $ctrl.parent.query;

		if (!$ctrl.entity) {
			var cached = UnifilarParametersCache.get(params.id);
			if (cached) {
				$ctrl.entity = cached;
			} else {
				$http.get('api/plans/' + params.id + '/queryByFilterForSegments', {
					params: $ctrl.queryFromParent
				})
					.then(function(response) {
						$ctrl.entity = response.data.sort(function(a, b) {
							return a.headMilestone - b.headMilestone;
						});
						UnifilarParametersCache.set(params.id, $ctrl.entity);
					});
			}
		}
  };

  $ctrl.export = () => {
    var url = 'api/plans/exportSegments?planId=' + planId;
    window.location.href = url;
  }

  $ctrl.showConfirmModal = () => {
    $ctrl.isConfirming = true;
  };
  
  $ctrl.cancelImport = () => {
    $ctrl.isConfirming = false;
  };

  // Converts a km value from Excel/screen to a number (accepts comma as decimal separator).
  function toKm(value) {
    if (value === null || value === undefined || value === '') {
      return NaN;
    }
    if (typeof value === 'number') {
      return value;
    }
    return parseFloat(String(value).replace(',', '.').trim());
  }

  // Compares km values with tolerance to avoid floating-point false negatives.
  function sameKm(a, b) {
    return Math.abs(a - b) < 1e-6;
  }

  // Validates that the file's Initial/Final km exactly match the plan's full segment list from the backend.
  // Returns { key, params } of the translatable error message when invalid, or null when valid.
  $ctrl.validateImport = (imported, baseline) => {
    var screen = (baseline || []);

    if (!imported.length) {
      return { key: 'unifilar_parameters.import.empty' };
    }

    // All rows must have numeric Initial km and Final km.
    for (var i = 0; i < imported.length; i++) {
      if (isNaN(toKm(imported[i].headMilestone)) || isNaN(toKm(imported[i].tailMilestone))) {
        return { key: 'unifilar_parameters.import.invalidKm', params: { line: i + 1 } };
      }
    }

    // The number of segments must be identical.
    if (imported.length !== screen.length) {
      return { key: 'unifilar_parameters.import.countMismatch', params: { imported: imported.length, screen: screen.length } };
    }

    // Compare pair by pair, both sorted by Initial km.
    var screenSorted = screen.slice().sort((a, b) => toKm(a.headMilestone) - toKm(b.headMilestone));
    var importedSorted = imported.slice().sort((a, b) => toKm(a.headMilestone) - toKm(b.headMilestone));

    for (var j = 0; j < screenSorted.length; j++) {
      var sh = toKm(screenSorted[j].headMilestone);
      var st = toKm(screenSorted[j].tailMilestone);
      var ih = toKm(importedSorted[j].headMilestone);
      var it = toKm(importedSorted[j].tailMilestone);

      if (!sameKm(sh, ih) || !sameKm(st, it)) {
        return {
          key: 'unifilar_parameters.import.kmMismatch',
          params: { importedHead: ih, importedTail: it, screenHead: sh, screenTail: st }
        };
      }
    }

    return null;
  };

  // Validates that the file follows the "Unifilar Segments Comments" template exported by the system.
  // The title (row 1, column A) contains "Unifilar" in all locales (pt/en/es); files from other
  // templates (e.g. Gaps, other reports, altered layout) are rejected even if km values match.
  // Returns { key, params } of the translatable error message when invalid, or null when valid.
  $ctrl.validateLayout = (jsonData) => {
    if (!jsonData || jsonData.length < 4) {
      return { key: 'unifilar_parameters.import.layout' };
    }

    var title = String((jsonData[0] && jsonData[0][0]) || '').toLowerCase();
    if (title.indexOf('unifilar') === -1) {
      return { key: 'unifilar_parameters.import.notUnifilar' };
    }

    return null;
  };

  $ctrl.upload = (files) => {
    $ctrl.isConfirming = false;
    if (!$ctrl.readonly && files && files.length) {
        var file = files[0];
        var reader = new FileReader();

        reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, { type: 'array' });

            // Assume the relevant content is on the first sheet.
            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];

            // Convert spreadsheet content to JSON.
            var jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            // Only accept the Unifilar Segments Comments template exported by the system.
            var layoutError = $ctrl.validateLayout(jsonData);
            if (layoutError) {
              AlertService.error(layoutError.key, layoutError.params);
              $timeout(() => {});
              return;
            }

            // Parses and formats date values to DD/MM/YYYY.
            function parseDate(value) {
              if (typeof value === 'number') {
                  // Convert Excel serial date to UTC to avoid timezone offset issues.
                  let excelDate = new Date(Math.round((value - 25569) * 86400000));
                  return excelDate.getUTCDate().toString().padStart(2, '0') + '/' +
                         (excelDate.getUTCMonth() + 1).toString().padStart(2, '0') + '/' +
                         excelDate.getUTCFullYear();
              }
              if (typeof value === 'string') {
                  let datePattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
                  if (datePattern.test(value)) {
                      return value;
                  }
              }
              return value;
            }

            // Build entity list from spreadsheet rows (skip the 3-row header).
            var newEntities = jsonData.slice(3).map(function(row) {
                return {
                  headMilestone: row[0],
                  tailMilestone: row[1],
                  dateConclusion: parseDate(row[2]),
                  expectedSolution: row[3],
                  workItem: row[4],
                  startDate: parseDate(row[5]),
                  endDate: parseDate(row[6]),
                  comments: row[7],
                  status: row[8]
                };
            })
            // Discard fully empty rows (no km at all) that may appear at the end of the spreadsheet.
            .filter(row => !(isNaN(toKm(row.headMilestone)) && isNaN(toKm(row.tailMilestone))));

            // Baseline = full segment list from the backend (same source as the Export button),
            // NOT the screen entity which may be paginated/filtered by the parent's km range.
            $http.get('api/plans/' + planId + '/segments')
              .then(function(response) {
                var fullSegments = response.data || [];

                // Accept only if every Initial/Final km exactly matches the plan's full segment list.
                var validationError = $ctrl.validateImport(newEntities, fullSegments);
                if (validationError) {
                  AlertService.error(validationError.key, validationError.params);
                  return;
                }

                $ctrl.entity = newEntities;
                UnifilarParametersCache.set(planId, $ctrl.entity);
                AlertService.success('entity.import.message', {
                  type: 'segments',
                  name: 'Observações'
                });
              }, function() {
                AlertService.error('unifilar_parameters.import.loadError');
              });
        };

        reader.readAsArrayBuffer(file);
    }
  };

  $ctrl.save = () => {
    $http
      .put('api/plans/' + $ctrl.state.params.id + '/segments', $ctrl.entity)
      .then(function (response) {
        if (response.status == 200) {
          UnifilarParametersCache.clear(planId);
          AlertService.success('entity.update.message', {
            type: 'segments',
            name: 'Observações'
          });
          $ctrl.isSaving = false;
          $state.go('^', {}, { reload: true });
        } else {
          $ctrl.isSaving = false;
        }
      });
  };
}

const component = {
  templateUrl,
  controller: Controller,
  require: {
    parent: '^unifilarParametersResult'
  },
  bindings: {
    $transition$: '<'
  }
};

app.component('unifilarParametersEditComments', component);
